import { useServiceWorkerVersion } from "~/features/pwa/use-service-worker-version";
import { useRootData } from "~/hooks/use-root-data";
import { useTwa } from "~/hooks/use-twa";

export const useEnvironmentVariables = () => {
  const rootData = useRootData();
  const { serviceWorkerVersion } = useServiceWorkerVersion();

  const { currentAppId } = useTwa();
  const serverVersion = rootData?.version || "Ukjent";
  const clientVersion = import.meta.env.VERSION || "Ukjent";
  const swVersion = serviceWorkerVersion || "Ukjent";

  const vyEnv = rootData?.env || "?";
  const nodeEnv = import.meta.env.NODE_ENV || "?";
  const isMocking = String(rootData?.isMocking);

  return {
    currentAppId,
    serverVersion,
    clientVersion,
    swVersion,
    vyEnv,
    nodeEnv,
    isMocking,
  };
};
